import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Button } from "pepsico-ds";
import PropTypes from "prop-types";
import { useState } from "react";
import { CODE_GROUP_CREATION_TYPE } from "../../utils/constants";
import "./codeGroupCreationTypeModal.scss";

const CodeGroupCreationTypeModal = ({ showModal, setShowModal, onSelectType }) => {
  const [selected, setSelected] = useState(null);
  const onCloseModal = () => {
    setShowModal(false);
  };

  const handleSelectType = () => {
    if (selected) {
      onSelectType(selected);
      onCloseModal();
    }
  };

  return (
    <Dialog
      className="creation-type-modal"
      open={showModal}
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" direction="row">
          <Grid item xs={11}>
            <h2
              data-testid="creation-type-modal-title"
              style={{ textAlign: "center" }}
            >
              Select Code Group Type
            </h2>
          </Grid>
          <Grid item xs={1} display="flex" justifyContent="flex-end">
            <CloseIcon
              onClick={onCloseModal}
              className="cursor-pointer"
              data-testid="closeIcon"
            />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "2rem",
        }}
      >
        <div className="creation-type-options">
          <div
            className={`creation-type-card ${selected === CODE_GROUP_CREATION_TYPE.PRE_GENERATED ? "selected" : ""}`}
            onClick={() => setSelected(CODE_GROUP_CREATION_TYPE.PRE_GENERATED)}
            data-testid="pre-generated-option"
          >
            <div className="creation-type-card-header">
              <h3>Upload List</h3>
            </div>
            <div className="creation-type-card-content">
              <p>
                Upload a document (CSV) featuring your collection of unique codes.
              </p>
            </div>
          </div>
          <div
            className={`creation-type-card ${selected === CODE_GROUP_CREATION_TYPE.SYSTEM_GENERATED ? "selected" : ""}`}
            onClick={() => setSelected(CODE_GROUP_CREATION_TYPE.SYSTEM_GENERATED)}
            data-testid="system-generated-option"
          >
            <div className="creation-type-card-header">
              <h3>System Generated</h3>
            </div>
            <div className="creation-type-card-content">
              <p>
                Set up a designated batch of unique codes based on your requirements.
              </p>
            </div>
            <div className="creation-type-card-footer"></div>
          </div>
        </div>

        <div className="display-flex align-items-center justify-content-end mt-3">
          <Button
            variant="tertiary"
            size="medium"
            onClick={onCloseModal}
            className="mr-2"
          >
            Cancel
          </Button>
          <Button variant="primary" size="medium" onClick={handleSelectType}>
            Select
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

CodeGroupCreationTypeModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  onSelectType: PropTypes.func.isRequired,
};

export default CodeGroupCreationTypeModal;
